// extracted by mini-css-extract-plugin
module.exports =  {"root":"oFatkeN2we6xc7oSlXIx"};